import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

import { SubItems, SubItem, SubLink } from "~/components/Subnav";

import transition from "~/utilities/transition";
import trackNavigationEvent from "~/utilities/trackNavigationEvent";
import { languageLabel } from "~/utilities/translations";

import { useTranslationContext } from "~/context/TranslationContext";

const Wrapper = styled.div`
    ${transition({}, "opacity", "visibility")};
    position: absolute;
    top: calc(100% + 1px);
    left: ${({ isPageHeader }) => (isPageHeader ? `0` : `unset`)};
    right: ${({ isPageHeader }) => (isPageHeader ? `unset` : `0`)};
    background-color: ${({ theme }) =>
        theme.colors.backgroundColor.defaultLight};
    opacity: ${({ isOpen }) => (isOpen ? `1` : `0`)};
    visibility: ${({ isOpen }) => (isOpen ? `visible` : `hidden`)};
    z-index: ${({ theme }) => theme.zIndex.navWrapper};
    box-shadow: 0 3px 2px 0 rgba(0, 0, 0, 0.5);
    min-width: 250px;
`;

const StyledSubLink = styled(SubLink)`
    min-width: 10rem;
    font-size: 1.4rem;
    color: ${({ theme, isActive }) =>
        isActive ? theme.colors.typography.linksHover : theme.palette.black};
`;

const LanguageSubnav = ({
    items,
    isOpen = false,
    topLinkLabel = "",
    isPageHeader = false,
}) => {
    const { activeCode, setActiveCode } = useTranslationContext();

    return (
        <Wrapper {...{ isOpen, isPageHeader }}>
            <SubItems>
                {items.map(
                    ({
                        linkLabel,
                        linkUrl,
                        linkNativeName,
                        linkTranslatedName,
                        languageCode,
                        isActive,
                    }) => {
                        return (
                            <SubItem key={`${languageCode}-${linkUrl}`}>
                                <StyledSubLink
                                    {...{
                                        topLinkLabel,
                                        isActive,
                                    }}
                                    to={linkUrl}
                                    onClick={() => {
                                        setActiveCode(languageCode);
                                        trackNavigationEvent(
                                            false,
                                            2,
                                            `Language Dropdown > ${linkLabel}`,
                                        );
                                    }}
                                >
                                    {languageLabel(
                                        linkLabel,
                                        linkNativeName,
                                        linkTranslatedName,
                                        languageCode,
                                        activeCode,
                                    )}
                                </StyledSubLink>
                            </SubItem>
                        );
                    },
                )}
            </SubItems>
        </Wrapper>
    );
};

LanguageSubnav.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({})),
    isOpen: PropTypes.bool,
    topLinkLabel: PropTypes.string,
    isPageHeader: PropTypes.bool,
};

export default LanguageSubnav;
